import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { generateImageSource } from '../../../utils/generateImageSource';
import { useStore } from '../../../store/index';

export const LandingPageHelpText = observer(() => {

  const {
    authStore: {
      isNotLoggedIn,
      authorized,
      proxtraSuspended,
      notProUser
    }
  } = useStore();

  const [redirectPath, updateRedirectPath] = useState('');

  useEffect(() => {
    updateRedirectPath(`?redirect=${window.location.pathname}`);
  }, []);

  if ((!isNotLoggedIn && !notProUser && !authorized && !proxtraSuspended) || authorized) {
    return null;
  }

  return (
    <div className="landingBanner__enrollment-help-text">
      <div>
        <img src={generateImageSource('/images/v1/info-icon.svg')} alt="info icon" />
      </div>
      <div>
        {
          renderMessage()
        }
      </div>
    </div>
  );

  function renderMessage() {
    if (isNotLoggedIn) {
      return (
        <p><span>Pro Customers must log in to their Pro Xtra accounts to access</span>
          <br />
          Please <a href={`/auth/view/signin${redirectPath}`}>Log In</a> or <a href="https://www.homedepot.com/auth/view/createaccount/proxtra?redirect=/path-to-pro-network">join</a> Pro Xtra
        </p>
      );
    }
    if (notProUser) {
      return (
        <>
          <p><span>You must be a Pro Xtra member to request access to this service.</span>
            <br />
              Pro Xtra is The Home Depot loyalty program built just for Pros. <a target="_blank" rel="noreferrer" href="/account/view/profile/">Join now</a> for member-only benefits, including the Path to Pro Network.
          </p>
          <p style={{ marginTop: '20px' }}><em>Note: If you choose to join Pro Xtra, click the link above, enter your personal information, and <strong>then check the box "I'm a Pro Customer"</strong> before submitting. <strong>You must click this checkbox to become a Pro Xtra member.</strong> Follow the instructions and refresh this tab once completed.</em></p>
        </>
      );
    }
    if (proxtraSuspended) {
      return (
        <p>
          To access Path to Pro, a Pro Xtra account is required. Your account is currently inactive. Please contact Customer Care at 1-866-333-3551 for more information.
        </p>
      );
    }
  }
});
